// extracted by mini-css-extract-plugin
export default {"section":"AdditionalResources_section__IRSyx"};